import { render } from "./Complaint.vue?vue&type=template&id=0ca02c34&scoped=true"
import script from "./Complaint.vue?vue&type=script&lang=js"
export * from "./Complaint.vue?vue&type=script&lang=js"

import "./Complaint.vue?vue&type=style&index=0&id=0ca02c34&scoped=true&lang=css"

import exportComponent from "D:\\project\\web\\clue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca02c34"]])

export default __exports__